/**
 * The one `new Worker(new URL(...))` — kept as its own module so the bundler's
 * worker detection sees the literal shape it needs, and so the hook that owns the
 * worker's lifecycle can be tested with a stand-in (the `import.meta.url` here does
 * not compile under the CommonJS test transform).
 */
export const createUploadWorker = () =>
  new Worker(new URL('./Upload.worker.ts', import.meta.url));
